import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { ClientPrescriptionsAggregateDto } from '../../dtos/clinical-history.dto';

@Injectable()
export class ClientPrescriptionsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  // `GET /api/clients/{clientId}/prescriptions` (`[Authorize(Policy = ModulePolicyNames.ClientsRead)]`,
  // see `ClientsController.GetPrescriptions`). Single aggregate object: no pagination, one bundle per
  // patient.
  public getForClient(clientId: string): Observable<ClientPrescriptionsAggregateDto> {
    return this.http.get<ClientPrescriptionsAggregateDto>(
      `${this.apiUrl}${API_ENDPOINTS.clients.prescriptions(clientId)}`,
    );
  }

  // `GET /api/clients/{clientId}/patients/{patientId}/prescriptions/{externalId}/pdf` -- the
  // backend generates the PDF fresh on every call (ProVet has no native PDF endpoint for
  // prescriptions), so this no longer depends on `documentId` at all.
  public downloadPdf(clientId: string, patientId: string, prescriptionExternalId: string, locale: string): Observable<Blob> {
    return this.http.get(
      `${this.apiUrl}${API_ENDPOINTS.clients.prescriptionPdf(clientId, patientId, prescriptionExternalId)}`,
      { params: { locale }, responseType: 'blob' },
    );
  }
}
